export var DAY_TODAY = 'today';
export var DAY_TOMORROW = 'tomorrow';